import { combineSlices } from '@reduxjs/toolkit';
import { outletsSlice } from '../outlets/outletsSlice';
import { schedulesSlice } from '../schedules/schedulesSlice';
import { macrosSlice } from '../macros/macrosSlice';
import { devicesSlice } from '../devices/devicesSlice';
import { hastaReceiversSlice } from '../../reducers/hastaReceiversSlice';
import { hastaTransmittersSlice } from '../../reducers/hastaTransmittersSlice';
import { nexaReceiversSlice } from '../../reducers/nexaReceiversSlice';
import { nexaTransmittersSlice } from '../../reducers/nexaTransmittersSlice';
import { mandolynsSlice } from '../../reducers/mandolynsSlice';
import { panelsSlice } from '../panels/panelsSlice';
import { panelGroupsSlice } from '../panel_groups/panelGroupsSlice';
import { panelDevicesSlice } from '../panel_devices/panelDevicesSlice';
import { zigbeeNodesSlice } from '../zigbee_nodes/zigbeeNodesSlice';
import { zigbeeNodeDescriptorsSlice } from '../zigbee_node_descriptors/zigbeeNodeDescriptorsSlice';
import { zigbeeNodeNeighborsSlice } from '../zigbee_node_neighbors/zigbeeNodeNeighborsSlice';
import { zigbeeNodeBindingTableSlice } from '../zigbee_node_binding_table/zigbeeNodeBindingTableSlice';
import { entitiesSlice } from '../../reducers/entitiesSlice';
import { actionsSlice } from '../../reducers/actionsSlice';
const a = combineSlices(actionsSlice, entitiesSlice, outletsSlice, schedulesSlice, macrosSlice, hastaReceiversSlice, hastaTransmittersSlice, nexaReceiversSlice, nexaTransmittersSlice, mandolynsSlice, devicesSlice, panelsSlice, panelGroupsSlice, panelDevicesSlice, zigbeeNodesSlice, zigbeeNodeDescriptorsSlice, zigbeeNodeNeighborsSlice, zigbeeNodeBindingTableSlice);
export default a;
